<div class="application-status-page">
  <header class="header-bar">
    <img src="logo.png" alt="Logo" class="logo">
  </header>
  
  <main class="main-content">
    <h1>Your application is under review</h1>
    <p class="message">
      After review, we were not able to approve this application.
    </p>
  </main>
</div>
